const errorCodes = {
    internal: {
        REQUEST_VALIDATION_ERROR: '2-12-1',
        ACCOUNT_EXISTS: '2-12-4',
        VPN_SETTING_RESTRICT_OPERATION: '2-12-15',
        DEVICE_LIMIT_EXCEEDED: '2-12-16',
        PROFILE_NOT_READY: '2-12-22',
        SUBNET_EXHAUSTED: '2-15-1',

        EMAIL_ERROR: '7-12-1',
    },
    networks: {
        REQUEST_VALIDATION_ERROR: '9-11-1',
        GENERATION_IN_PROGRESS: '9-11-2',
        REMOVE_LAST_CONNECTOR: '9-11-59',
    },
    networkManagement: {
        PROFILE_NOT_READY: '31-12-22',
    },
    ipAssignment: {
        SUBNET_EXHAUSTED: '14-11-7',
        IP_ALLOCATION_FAIL: '14-12-1',
    },
    profile: {
        BUNDLING_IN_PROGRESS_ERROR: '18-11-3',
    },
    userManagement: {
        OPERATION_RESTRICTED: '21-11-5',
        DEVICE_LIMIT_EXCEEDED: '21-11-6',
        PROFILE_DISTRIBUTION: '21-11-18',
        DEVICE_ENFORCEMENT_LEVEL_2: '21-11-48',
        RESTRICTED_DEVICE_NOT_FOUND: '21-11-45',
        PROFILE_NOT_READY: '29-12-22',
    },
} as const;

function mapToLegacyErrorCode(code: string) {
    if (typeof code !== 'string') {
        return code;
    }

    if (code.startsWith('7-')) {
        return errorCodes.internal.EMAIL_ERROR;
    }

    if (code.endsWith('-11-1')) {
        return errorCodes.internal.REQUEST_VALIDATION_ERROR;
    }

    if (code === errorCodes.ipAssignment.IP_ALLOCATION_FAIL) {
        return errorCodes.internal.SUBNET_EXHAUSTED;
    }

    if (
        [
            errorCodes.profile.BUNDLING_IN_PROGRESS_ERROR,
            errorCodes.networks.GENERATION_IN_PROGRESS,
            errorCodes.networkManagement.PROFILE_NOT_READY,
            errorCodes.userManagement.PROFILE_NOT_READY,
        ].includes(code as any)
    ) {
        return errorCodes.internal.PROFILE_NOT_READY;
    }

    return code;
}

export { errorCodes, mapToLegacyErrorCode };
